import React from 'react'
import styled from 'styled-components'

import CMS from '@talus-analytics/library.airtable-cms'
import useIndexPageData from '../../../cmsHooks/useIndexPageData'
import { Link } from 'gatsby'

import { FullWidthSection, ContentContainer } from '../../layout'
import device from '../../../utilities/device'
import { ActionButton } from '../../ui'

const ShortTagline = styled.p`
  font-size: 26px;
  color: ${({ theme }) => theme.colorVeryDarkBlue};
  font-weight: 600;
  margin-top: 20px;
  @media ${device.laptop} {
    font-size: 20px;
  }
  @media ${device.mobileL} {
    font-size: 16px;
  }
`
const FullTagline = styled.div`
  font-size: 30px;
  color: ${({ theme }) => theme.colorVeryDarkBlue};
  margin: 40px 0px;
  line-height: 1.5em;
  @media ${device.laptop} {
    font-size: 24px;
    margin-top: 20px;
  }
  @media ${device.mobileL} {
    font-size: 18px;
  }
`
const Heading = styled.h1`
  margin-top: 30px;
  color: ${({ theme }) => theme.colorWhite};
  span {
    color: ${({ theme }) => theme.colorDarkBlue};
    font-weight: 600;
  }
`
const Grid = styled.div`
  display: grid;
  grid-template-columns: 3.5fr 5fr;
  column-gap: 40px;
  @media ${device.laptop} {
    grid-template-columns: 1fr;
  }
`
const HeroImage = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media ${device.laptop} {
    justify-content: center;
    margin-top: 30px;
  }
`
const TextContent = styled.div`
  @media ${device.laptop} {
    max-width: 60%;
    margin: 0 auto;
  }
  @media ${device.tablet} {
    max-width: 80%;
  }
`
const HeroSection = (): JSX.Element => {
  const data = useIndexPageData()

  return (
    <FullWidthSection gradient>
      <ContentContainer>
        <Grid>
          <TextContent>
            <ShortTagline>
              <CMS.Text name="All caps tagline" data={data} />
            </ShortTagline>
            <Heading>
              <CMS.Text name="Main headline" data={data} />
              <span>
                <CMS.Text name="Product name" data={data} />
              </span>
            </Heading>
            <FullTagline>
              <CMS.Text name="Main tagline" data={data} />
            </FullTagline>
            <Link to="/contact">
              <ActionButton white>Contact us</ActionButton>
            </Link>
          </TextContent>
          <HeroImage>
            <CMS.Image name="Product mockup" data={data} />
          </HeroImage>
        </Grid>
      </ContentContainer>
    </FullWidthSection>
  )
}

export default HeroSection
